import gql from 'graphql-tag';
import ImageDataFragment from './ImageData.gql';

export default gql`
  fragment ImageSliderItemFragment on ImageSliderItem {
    id
    type
    data {
      image1 {
        ...ImageDataFragment
      }
      image2 {
        ...ImageDataFragment
      }
    }
  }
  ${ImageDataFragment}
`;
